import {
    Box,
    Button,
    InputLabel,
    TextField,
    Typography,
    InputAdornment,
    IconButton,
    Paper,
  } from '@mui/material';
  import React, { useState } from 'react';
  import { useForm, Controller } from "react-hook-form";
  import { useNavigate } from 'react-router-dom';
  import { useSnackbar } from 'notistack';
  import { adminLogin } from '../../redux/adminSlice';
  import { useDispatch } from 'react-redux';
  import { useTranslation } from 'react-i18next';
  import Visibility from '@mui/icons-material/Visibility';
  import VisibilityOff from '@mui/icons-material/VisibilityOff';
  
  export default function AdminLogin() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { closeSnackbar, enqueueSnackbar } = useSnackbar();
    const [showPassword, setShowPassword] = useState(false);
  
    const { register, control, formState: { errors }, handleSubmit } = useForm({
      defaultValues: { email: '', password: '' }
    });
  
    const handleClickShowPassword = () => setShowPassword(prev => !prev);
  
    async function onSubmit(data) {
      closeSnackbar();
      try {
        const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/admin/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data)
        });
        const resData = await response.json();
        if (response.status !== 200 && response.status !== 201) {
          enqueueSnackbar(resData.message, { variant: "error", autoHideDuration: 8000 });
          throw new Error('Login failed');
        }
  
        localStorage.clear();
        const now = new Date().toLocaleString();
        dispatch(adminLogin({ admin: { ...resData.data, loginDate: now }, token: resData.token }));
        navigate('/admin');
        enqueueSnackbar(t("Admin login successfully"), { variant: "success", autoHideDuration: 8000 });
      } catch (err) {
        console.error(err);
      }
    }
  
    return (
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        

        {/* القسم الأيمن للنموذج */}
        <Box sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4
        }}>
          <Paper elevation={3} sx={{ width: '100%', maxWidth: 500, p: 4, borderRadius: 2 }}>
            <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 600 }}>
              Admin Login
            </Typography>
  
            <form onSubmit={handleSubmit(onSubmit)} noValidate dir={"ltr"}>
              <Box sx={{ mb: 3 }} >
                <InputLabel htmlFor="email">Email</InputLabel>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      id="email"
                      type="email"
                      fullWidth
                      variant="outlined"
                      error={!!errors.email}
                      helperText={errors.email?.message}
                    />
                  )}
                  rules={{ required: t("Email is required") }}
                />
              </Box>
  
              <Box sx={{ mb: 3 }}>
                <InputLabel htmlFor="password">{t("Password")}</InputLabel>
                <Controller
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      id="password"
                      type={showPassword ? "text" : "password"}
                      fullWidth
                      variant="outlined"
                      error={!!errors.password}
                      helperText={errors.password?.message}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={handleClickShowPassword} edge="end">
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  )}
                  rules={{ required: t("Password is required") }}
                />
              </Box>
  
              <Button variant="contained" fullWidth type="submit" sx={{ py: 1.5, fontSize: 16 }}>
                {t("Login")}
              </Button>
            </form>
          </Paper>
        </Box>
                {/* القسم الأيسر للصورة */}
                <Box sx={{
          flex: 1,
          backgroundColor: '#f5f5f5',
          display: {md:"flex",xs:"none"},
          alignItems: 'center',
          justifyContent: 'center',
          p: 4
        }}>
          <img
            src="https://server.moalime.com/drive/7.png" // استبدل بمسار الصورة الصحيح
            alt="Welcome"
            style={{ maxWidth: '100%', height: 'auto',border:"5px solid #3B82F6ED",borderRadius:"2rem" }}
          />
        </Box>
  
      </Box>
    );
  }
  